module.exports = __webpack_public_path__ + "img/lemonade.17dac1c7.svg";